import data from '../data';
import { wishTriggers } from '../main';
import config from '../config';
import { dlWishlistNbItemsData } from '../../events/wishlist/dl.wishlist.nbItems.data';
const wishCounters = () => {
    wishTriggers.on('listUpdated', () => {
        document.querySelectorAll(config.selector.count).forEach(elem => {
            elem.innerHTML = data.itemCount > 0 ? `(${data.itemCount})` : '';
        });
        document.querySelectorAll(config.selector.countHidden).forEach(elem => {
            elem.innerHTML = data.itemCount > 0 ? data.itemCount.toString() : '';
            elem.hidden = data.itemCount < 1;
        });
        dlWishlistNbItemsData(data.itemCount);
    });
};
export default wishCounters;
